/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CourseModulesLinkingDashboard from "../../../components/CourseContentManagement/CourseLinking";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const CourseModulesLinking = () => {
  const navigate = useNavigate();

  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};

  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.courseContentManagement?.hasModuleLinkingAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <CourseModulesLinkingDashboard ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CourseModulesLinking;
